import styled from 'styled-components'
import { theme } from '@provi/provi-components'

export const Section = styled.div``

export const Underline = styled.span`
  text-decoration: underline ${({ underlineColor }) => underlineColor || theme.colors.blue900};
  color: ${({ color }) => color || theme.colors.blue900};
`
